var ExtensionHelperModel = function () {
    var that = this;

    //baseData
    that.ExtensionId = ko.observable();
    that.Object_ObjectExtensionId = ko.observable();
    that.LocalizationKey = ko.observable();

    //subData
    that.SelectedExtensionObjectValues = ko.observableArray();

    //flags
    that.IsDisabled = ko.observable(false);
};